import axios from "@/utils/axios.js";
import Cookies from "js-cookie";

/**
 * 获取当前登录经纪人信息，登录状态
 */
export async function getAgent() {
  return axios.get("/customReport/getAgent");
}

/**
 * 登陆授权
 */
export async function getLogin() {
  const openId = Cookies.get("openid");
  return axios.get("/agentLogin/getLoginUserByOwxOpenId", {
    params: { owxOpenId: openId }
  });
}
/**
 * 新登录授权
 */
export async function getLoginNew() {
  const openId = Cookies.get("openid");
  return axios.get(`/agentAccount/loginByCityOpenId/${openId}`);
}
